export const ACTIVE_TOOL_SESSION_STORAGE_KEY = 'admin_toolbox_active_tool';
export const FIGMA_CAPTURE_SCRIPT_URL =
  'https://mcp.figma.com/mcp/html-to-design/capture.js';
